import type { BookingType } from "@/lib/miscellaneous/group-by-booking";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type OrderEntry = {
  key: number;
  value: [string, string];
};

interface SortingOrderState {
  sortOrderSet: OrderEntry[];
  setSortOrderSet: (bookings: BookingType[]) => void;
  addSortOrder: (bookingId: BookingType["id"], lineItemIds: string[]) => void;
}

export const useSortingOrderStore = create<SortingOrderState>()(
  persist(
    (set, get) => ({
      sortOrderSet: [],

      setSortOrderSet: (bookings) => {
        const next = [...get().sortOrderSet];

        const maxKey = next.reduce((max, entry) => Math.max(max, entry.key), 0);

        bookings.forEach((b, index) => {
          const bookingKey = b.id;
          const lineIds = b.subRows.map((sr) => sr.id).join("-");

          const existingEntry = next.findIndex(
            (entry) =>
              entry.value[0] === bookingKey || entry.value[1] === lineIds,
          );

          if (existingEntry !== -1) {
            next[existingEntry].value = [bookingKey, lineIds];
          } else {
            next.push({
              key: maxKey + index,
              value: [bookingKey, lineIds],
            });
          }
        });

        set({ sortOrderSet: next });
      },

      addSortOrder: (bookingId, lineItemIds) => {
        const next = [...get().sortOrderSet];
        const bookingKey = bookingId;
        const lineIds = lineItemIds.join("-");
        const maxKey = next.reduce(
          (max, entry) => Math.max(max, entry.key),
          -1,
        );

        const existingIdx = next.findIndex(
          (entry) =>
            entry.value[0] === bookingKey || entry.value[1] === lineIds,
        );

        if (existingIdx !== -1) {
          next[existingIdx].value = [bookingKey, lineIds];
        } else {
          next.push({
            key: maxKey + 1,
            value: [bookingKey, lineIds],
          });
        }

        set({ sortOrderSet: next });
      },
    }),
    {
      name: "invoice-bookings-sort-order",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
